export default "__VITE_ASSET__BXWUZ76c__"